<template>
  <v-window v-model="step" data-qa="billpaymentshistory-window-2983s">
  <v-window-item :value="1" data-qa="billpaymentshistory-window-item-40tbtp">
  <v-flex class="billPayments" data-qa="billpaymentshistory-flex-tqzhc">
    <v-layout wrap class="ml-2 billPayments--gradientBGposition" data-qa="billpaymentshistory-layout-3hfkta">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="billpaymentshistory-flex-dt939">
        <v-container class="billPayments--title-padding" data-qa="billpaymentshistory-container-keok8g">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="billpaymentshistory-flex-v3937m">
            <v-row no-gutters data-qa="billpaymentshistory-row-8edh65">
              <v-layout row wrap class="pb-2 pl-12" data-qa="billpaymentshistory-layout-hkqcz">
                <div class="pt-3" data-qa="billpaymentshistory-div-hw8s5e">
                <v-avatar :tile="false" size="35" color="white" data-qa="billpaymentshistory-avatar-cjce7">
                  <v-icon :color="primaryColor" data-qa="billpaymentshistory-icon-8l28jcg">mdi-receipt</v-icon>
                </v-avatar>
                </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="billpaymentshistory-flex-jxma4p">
                  <v-row no-gutters data-qa="billpaymentshistory-row-5zt79">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("billPayments.title")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <!-- HISTORY CARD -->
    <v-flex
      xs12
      sm12
      md12
      lg12
      xl12
      class="billPayments--content-padding billPayments--overlayCardFlex"
     data-qa="billpaymentshistory-flex-dz7ly">
      <v-layout row wrap class="billPayments--content-padding"  data-qa="billpaymentshistory-layout-9f1089">
        <v-col cols="12" class="hidden-md-and-up bottom--pb10" data-qa="billpaymentshistory-col-6y046q">
          <new-payment-btn
            :text="$t('billPayments.newBillPaymentLabel')"
            @click="gotoBillPayments"
          />
        </v-col>
        <v-flex xs12 sm11 md9 lg9 xl9 class="pt-0" data-qa="billpaymentshistory-flex-78qy07">
          <v-card data-qa="billpaymentshistory-card-42z8fd">
            <v-container data-qa="billpaymentshistory-container-05k92m">
              <v-layout row justify-space-between data-qa="billpaymentshistory-layout-nbpqqq">
                <!-- <v-layout column wrap data-qa="billpaymentshistory-layout-zsskms"> -->
                <v-flex xs12 sm12 md12 lg12 xl12 class="pa-4 bottom--pb30" data-qa="billpaymentshistory-flex-znomag">
                  <font class="text-h6 font-weight-light"
                    >{{ $t("billPayments.paymentHistory") }}</font>
                </v-flex>
                  <v-flex xs12 sm12 md12 lg12 xl12 data-qa="billpaymentshistory-flex-p3d8oo">
                    <v-autocomplete
                      :label= "$t('billPayments.filterByBiller')"
                       dense
                      filled
                      :color="primaryColor"
                      class="mt-xs-auto mt-sm-auto mt-md-auto mt-n1 mt-xl-auto px-4"
                      :items="paymentUnfiltered"
                      v-model="billerFilter"
                      item-value="companyCode"
                      item-text="companyDescription"
                      @change="filterByBiller(billerFilter)"
                      append-icon=""
                      background-color="#f0eff7 !important"
                      clearable
                      prepend-inner-icon="mdi-magnify"
                     data-qa="billpaymentshistory-autocomplete-rs1fzj">
                    <template slot="no-data">
                        <v-list-item data-qa="billpaymentshistory-list-item-fpc69i">
                          <v-list-item-title data-qa="billpaymentshistory-list-item-title-ck0uij">
                            No Records found for your search in this page
                          </v-list-item-title>
                        </v-list-item>
                    </template>
                    </v-autocomplete>
                  </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 class="pl-2" data-qa="billpaymentshistory-flex-3b0bmi">
              <v-chip-group v-model="defaultFilter" :color="primaryColor" mandatory data-qa="billpaymentshistory-chip-group-ni7hk">
                <v-chip outlined class="ma-2" @click="showCustomFilterList" :color="primaryColor" data-qa="billpaymentshistory-chip-ln1mb">
                  {{ $t("billPayments.customFilter") }}
                </v-chip>
                <v-chip
                  v-if="chip3"
                  outlined
                  class="ma-2"
                  :color="primaryColor"
                  @click="last1MonthPayments"
                 data-qa="billpaymentshistory-chip-kf8zuq">
                  {{ $t("billPayments.last1Month") }}
                </v-chip>
                <v-chip
                  v-if="chip2"
                  outlined
                  class="ma-2"
                  :color="primaryColor"
                  @click="last2MonthsPayments"
                  @click:close="defaultFilter = 3"
                 data-qa="billpaymentshistory-chip-zazycs">
                  {{ $t("billPayments.last2Months") }}
                </v-chip>
                <v-chip
                  v-if="chip1"
                  outlined
                  class="ma-2"
                  :color="primaryColor"
                  @click="last6MonthsPayments"
                 data-qa="billpaymentshistory-chip-38plxo">
                  {{ $t("billPayments.last6Months") }}
                </v-chip>
              </v-chip-group>
            </v-flex>
      <v-expand-x-transition data-qa="billpaymentshistory-expand-x-transition-zyffwhl">
        <v-flex xs12 sm12 md12 lg8 xl8 data-qa="billpaymentshistory-flex-y8zlef">
          <v-row no-gutters v-show="expandCustomList" data-qa="billpaymentshistory-row-h638">
            <v-flex class="pl-4 pr-4 md-4" xs5 sm5 md4 lg4 xl4 data-qa="billpaymentshistory-flex-9v749o">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="billpaymentshistory-menu-zzh8a">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedFromDate"
                    :label="$t('billPayments.fromDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="fromDate"
                    :color="primaryColor"
                    :rules="fromDateRules"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  @input="menu = false"
                  :allowed-dates="allowedDates"

                  :max="currentDate"
                  data-qa="fromDate"
                  :color="primaryColor"
                  @change="updateFormattedDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex class="pl-4 pr-2 md-4" xs5 sm5 md4 lg4 xl4 data-qa="billpaymentshistory-flex-v5y86">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="billpaymentshistory-menu-5jnd3q">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedToDate"
                    :label="$t('billPayments.toDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="toDate"
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  @input="menu2 = false"
                  :allowed-dates="allowedDates"

                  :max="currentDate"
                  data-qa="toDate"
                  :color="primaryColor"
                  @change="updateFormattedDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs1 sm1 md2 lg1 xl1 class="pl-2 pr-4 pt-4 md-4" data-qa="billpaymentshistory-flex-3xgc8">
              <v-btn
                fab
                outlined
                small
                :color="primaryColor"
                @click="offset = 0;filterByDate(fromDate, toDate)"
                data-qa="filterByDate"
              >
                <v-icon dark class="material-symbols-outlined" data-qa="billpaymentshistory-icon-za93p">arrow_right_alt</v-icon>
              </v-btn>
            </v-flex>
          </v-row>
        </v-flex>
      </v-expand-x-transition>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  class="pa-12 billHistory--centre"
                  v-if="paymentHistory.length===0"
                 data-qa="billpaymentshistory-flex-1g8kzs">
                  <v-icon class="pb-7" light size="50" data-qa="billpaymentshistory-icon-tei4n9">mdi-receipt</v-icon>
                  <v-spacer data-qa="billpaymentshistory-spacer-9mlh5c"></v-spacer>

                  <font class="subheading-1 font-weight-bold"
                    >{{ $t("billPayments.noPaymentHistory") }}</font
                  >
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  md12
                  lg12
                  xl12
                  v-else
                 data-qa="billpaymentshistory-flex-38xw2u">
                   <v-list v-if="paymentHistory.length > 0" class="px-4" data-qa="billpaymentshistory-list-5j7hyd">
                <v-list-item-content
                class= "bottom--pb5 top--pt5"
                  v-for="(payment, index) in paymentHistory"
                  :key="index"
                  @click="getTemplateById(payment, index)"
                 :data-qa="`billpaymentshistory-list-item-content-qslwto-${index}`">
                  <v-card-text class="pa-2 billHistory--hover" :data-qa="`billpaymentshistory-card-text-y9ovsb-${index}`">
                    <v-layout wrap :data-qa="`billpaymentshistory-layout-aledp-${index}`">
                      <v-flex xs12 sm12 md12 lg7 xl7 :data-qa="`billpaymentshistory-flex-lsf6xt-${index}`">
                        <span
                          class="body-1 font-weight-regular"
                          v-text="payment.companyDescription+' '+ payment.serviceProvidedDescription+' '+ payment.categoryDescription"
                          :data-qa="`billpaymentshistory-span-a172n-${index}`"></span>
                      </v-flex>
                      <v-flex v-if="payment.paymentAmount" xs12 sm12 md12 lg5 xl5 class="textright hidden-sm-and-down" :data-qa="`billpaymentshistory-flex-cs9bqh-${index}`">
                        <span
                          class="billHistory--amount font-weight-bold"
                          :data-qa="`billpaymentshistory-span-4limrs-${index}`">{{$formatter.currency.format(payment.paymentAmount, payment.paymentCurrency)}}
                        </span>
                      </v-flex>
                      <v-flex v-if="payment.paymentAmount" xs12 sm12 md12 lg5 xl5 class="hidden-md-and-up" :data-qa="`billpaymentshistory-flex-p5i3zh-${index}`">
                        <span
                          class="billHistory--amount font-weight-bold"
                          :data-qa="`billpaymentshistory-span-e5ay59-${index}`">{{$formatter.currency.format(payment.paymentAmount, payment.paymentCurrency)}}
                        </span>
                      </v-flex>
                       <v-flex xs12 sm12 md12 lg12 xl12 :data-qa="`billpaymentshistory-flex-p5hmo-${index}`">
                        <span v-if="payment.paymentDate"
                           :color="primaryColor"
                           class="subtitle-2 font-weight-light"
                           :data-qa="`billpaymentshistory-span-t8b16-${index}`">{{  $formatter.formatDate(payment.paymentDate) }} | </span>
                        <span v-if="payment.paymentStatus=='SUCCESSFUL'"
                           :style="{ color: successColor }"
                           class="subtitle-1 font-weight-medium"
                           :data-qa="`billpaymentshistory-span-ff75wn-${index}`">{{payment.paymentStatus | capitalize}}</span>
                        <span v-else
                           :style="{ color: errorColor }"
                           class="subtitle-1 font-weight-medium"
                           :data-qa="`billpaymentshistory-span-f8wmyk-${index}`">{{payment.paymentStatus | capitalize}}</span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-divider :data-qa="`billpaymentshistory-divider-71brdi-${index}`"  v-if="!(index === paymentHistory.length - 1)" class="billHistory--flexBasis" />
                </v-list-item-content>
              </v-list>
                </v-flex>
                <!-- </v-row> -->
              </v-layout>
            </v-container>
          </v-card>
          <v-flex xs12 sm12 md12 lg12 xl12 class="pa-2" v-if="paymentHistory" data-qa="billpaymentshistory-flex-exlsd5">
        <v-pagination
          @input="paginationChangeHandler"
          :value="pagination.page"
          :length="pageNumbers"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
         data-qa="billpaymentshistory-pagination-zkl1vt"></v-pagination>
      </v-flex>
        </v-flex>
        <v-flex sm12 xs12 md3 lg3 xl3
          class="hidden-sm-and-down pl-3"
         data-qa="billpaymentshistory-flex-zxu0og">
          <new-payment-btn
            :text="$t('billPayments.newBillPaymentLabel')"
            @click="gotoBillPayments"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
  </v-window-item>
  <v-window-item :value="2" data-qa="billpaymentshistory-window-item-sa8awp">
    <payments-review-screen :configData="{ chargeInfo }" :displayData="display"></payments-review-screen>
  </v-window-item>
  <v-window-item :value="3" data-qa="billpaymentshistory-window-item-qvt3c">
    <bill-payments :config="repeatBillerTemplate"></bill-payments>
  </v-window-item>
  <ConfirmExit v-if="isLeavingRoute" v-on:isLeavingRoute="proceedLeave" v-on:isNotLeavingRoute="cancelLeave"/>
  </v-window>
</template>

<script>
import '@/styles/pages/billPayments.scss'
import PaymentsReviewScreen from './PaymentsReviewScreen.vue'
import BillPayments from './BillPayments.vue'
import ConfirmExit from '@/components/common/ConfirmExit.vue'
import event from '@/util/event'
import moment from 'moment'
import CommonService from '@/service/commonService.js'
import store from '@/core/store'
import button from '@/views/common/buttons/WrappedButton.vue'

export default {
  name: 'BillPaymentsHistory',
  components: {
    PaymentsReviewScreen,
    BillPayments,
    ConfirmExit,
    'new-payment-btn': button
  },
  data () {
    return {
      limit: 20,
      offset: 0,
      pagination: { rowsPerPage: 20, page: 1 },
      pageNumbers: 2,
      itemLinks: {},
      billHistoryInput: {},
      billerFilter: '',
      dateFilter: '',
      formattedDateFilter: '',
      menu: false,
      menu2: false,
      billers: [],
      paymentHistory: [],
      paymentUnfiltered: [],
      expandCustomList: false,
      defaultFilter: 1,
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: true,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      fromDateRules: [],
      currentDate: moment().format('YYYY-MM-DD'),
      minAllowedDate: moment().subtract(180, 'days').format('YYYY-MM-DD'),
      step: 1,
      display: {},
      chargeInfo: {},
      repeatBillerTemplate: {},
      additionalKeyDescription: [],
      additionalValues: [],
      additionalProps: [],
      customDataMap: [],
      fromAccountType: '',
      templateCheck: '',
      isLeavingRoute: false,
      isLogout: false,
      PaymentCompleted: false
      // additionalFieldsDescription: []
    }
  },
  async created () {
    this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
    this.formattedToDate = this.$formatter.formatDate(this.toDate)
    this.pageNumbers = 2
    this.offset = 0
    await this.last1MonthPayments(this.limit, this.offset)
    event.$on('goToHistory', async (repeatPayment) => {
      this.step = 1
      if (repeatPayment) {
        this.defaultFilter = 1
        await this.last1MonthPayments(this.limit, this.offset)
      }
    })
    event.$on('repeatTemplate', (arg1) => {
      this.step++
      this.repeatBillerTemplate = arg1
      this.repeatBillerTemplate.paymentTemplate = true
    })
    event.$on('navigateToRepeatPayment', () => {
      this.step--
    })
    event.$on('navigateToReviewHistory', (args) => {
      this.step = 2
    })
    event.$on('templateCheck', (arg) => {
      this.templateCheck = true
    })
    event.$on('paymentCompleted', (arg) => {
      this.templateCheck = false
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.templateCheck) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  methods: {
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    async paginationChangeHandler (pageNumber) {
      this.billerFilter = ''
      this.pagination.page = pageNumber
      if (this.pagination.page >= 1) {
        this.offset = (this.pagination.page - 1) * this.limit
        this.billHistoryInput = {}
        this.billHistoryInput.partyId = JSON.parse(
          sessionStorage.getItem('username')
        )
        this.billHistoryInput.limit = this.limit
        this.billHistoryInput.offset = this.offset
        var toDate = (this.defaultFilter === 0 && this.toDate) ? this.toDate : this.currentDate
        var fromDate = ''
        if (this.defaultFilter === 0) fromDate = this.fromDate
        else if (this.defaultFilter === 1 || this.defaultFilter === 2) { fromDate = this.getDate(this.defaultFilter * 30 - 1) } else if (this.defaultFilter === 3) fromDate = this.getDate(179)
        else fromDate = this.getDate(29)
        if (toDate && fromDate) await this.filterByDate(fromDate, toDate)
        this.showList = true
      }
    },
    setData () {
      // eslint-disable-next-line no-prototype-builtins
      if (this.itemLinks && Object.keys(this.itemLinks).length > 1 && this.itemLinks.hasOwnProperty('next')) {
        if (this.pageNumbers >= 2) {
          this.pageNumbers = this.pagination.page + 1
        } else {
          this.pageNumbers = this.pagination.page - 1
        }
      } else {
        this.pageNumbers = this.pagination.page
      }
      if (this.itemLinks && Object.keys(this.itemLinks).length === 1) {
        this.pageNumbers = this.pagination.page - 1
      }
      if (!this.itemLinks || Object.keys(this.itemLinks).length === 0) {
        this.pagination.page = 1
        this.pageNumbers = 0
      }
    },
    validateFilterDates () {
      if (this.toDate || this.fromDate) {
        const toDate = moment(this.toDate, 'YYYY-MM-DD')
        const fromDate = moment(this.fromDate, 'YYYY-MM-DD')
        const maxToDate = moment(fromDate).add(179, 'days')
        if (this.toDate && this.fromDate) {
          if (toDate > maxToDate) {
            this.fromDateRules = ['The maximum payment date range is 180 days']
          } else if (fromDate > toDate) {
            this.fromDateRules = [
              'Payment From Date must be lesser than Payment To Date'
            ]
          } else {
            this.fromDateRules = []
          }
        }
      }
    },
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    filterByBiller (billerFilter) {
      // this.defaultFilter = ''
      if (billerFilter) {
        this.paymentHistory = this.paymentUnfiltered.filter(
          (value) => billerFilter === value.companyCode
        )
      } else {
        this.paymentHistory = this.paymentUnfiltered
      }
    },
    async filterByDate (fromDate, toDate) {
      // this.defaultFilter = ''
      if (fromDate && toDate) {
        this.billHistoryInput = {}
        this.billHistoryInput.limit = this.limit
        this.billHistoryInput.offset = this.offset
        this.billHistoryInput.partyId = JSON.parse(
          sessionStorage.getItem('username')
        )
        this.billHistoryInput.fromDate = fromDate
        this.billHistoryInput.toDate = toDate
        await this.getBillPaymentHistory()
      } else {
        this.paymentHistory = this.paymentUnfiltered
      }
    },
    updateFormattedDate () {
      this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
      this.formattedToDate = this.$formatter.formatDate(this.toDate)
      this.validateFilterDates()
    },
    clearBillerFilter () {
      this.defaultFilter = 1
      this.paymentHistory = this.paymentUnfiltered
      this.billerFilter = ''
      this.dateFilter = ''
    },
    async getTemplateById (payment, index) {
      this.additionalKeyDescription = []
      this.customDataMap = []
      try {
        const templateInfo = await CommonService.getTemplate(payment.billerTemplateId)
        if (templateInfo) {
          if (templateInfo.additionalDataRequired) {
            this.additionalProps = templateInfo.additionalDataRequired
            templateInfo.additionalDataRequired.forEach((key) => {
              if (!this.additionalKeyDescription.includes(key.fieldDescription)) {
                this.additionalKeyDescription.push(key.fieldDescription)
              }
            })
            // Custom Data Fix
            templateInfo.additionalDataRequired.forEach((key, index) => {
              // if (!this.customDataMap.includes(key.fieldDescription)) {
              this.customDataMap[index] = { title: key.fieldDescription }
              this.customDataMap[index].subtitle = payment.additionalData && payment.additionalData[0] && payment.additionalData[0]['custom-fields'] && payment.additionalData[0]['custom-fields'][key.fieldName] ? payment.additionalData[0]['custom-fields'][key.fieldName] : ''
              // }
            })
          }
          if (templateInfo.maxAmountAllowed >= 0 && templateInfo.minimumAmountAllowed >= 0) {
            store.dispatch('userStore/setUserData', {
              repeatedBiller: templateInfo
            })
          }
          var causes = !!templateInfo.causes
          await this.onSelectPayment(payment, index, causes)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getAccountDetails (accountId) {
      const response = await CommonService.getAccountDetails(accountId)
      switch (response.accountType) {
        case 'SVGS':
          this.fromAccountType = 'Savings' + ' ' + '-' + ' ' + accountId
          this.chargeInfo.fromAccountType = this.fromAccountType
          break
        case 'CACC':
          this.fromAccountType = 'Current' + ' ' + '-' + ' ' + accountId
          this.chargeInfo.fromAccountType = this.fromAccountType
          break
      }
    },
    async onSelectPayment (payment, index, causes) {
      store.dispatch('userStore/setUserData', {
        billerCurrency: payment.billCurrency
      })
      if (payment.debitAccountNumber) {
        await this.getAccountDetails(payment.debitAccountNumber)
      }
      if (payment.paymentStatus === 'SUCCESSFUL') {
        // route to repeat payment in case of successful payments
        this.chargeInfo = {
          companyId: payment.companyDescription,
          debitAccountNumber: payment.debitAccountNumber,
          customerId: payment.customerIdWithBiller,
          reference: payment.billReference,
          dueDate: payment.paymentDate.split('-').reverse().join('-'),
          billAmount: payment.billAmount,
          consumerName: '',
          mobileNumber: '',
          additionalData: payment && payment.additionalData && payment.additionalData.length ? payment.additionalData : [],
          billerTemplateId: payment.billerTemplateId,
          fromAccountType: this.fromAccountType
        }
        if (payment && payment.additionalData && payment.additionalData.length && payment.additionalData[0]['custom-fields']) {
          this.additionalValues = Object.values(
            payment.additionalData[0]['custom-fields']
          )
        }
        this.display = {
          charge: payment.totalChargeAmount,
          totalAmount:
            Number(payment.totalChargeAmount) + Number(payment.billAmount),
          dueDate: '',
          id: payment.billerTemplateId,
          customerId: payment.customerIdWithBiller,
          reference: payment.billReference,
          otherFields: payment.additionalData,
          paymentDate: payment.paymentDate,
          repeatPayment: true,
          additionalKeyDescription: this.additionalKeyDescription,
          additionalValues: this.additionalValues,
          customDataMap: this.customDataMap,
          additionalProps: this.additionalProps
        }
        this.display.additionalProps = this.additionalProps
        this.display.causes = causes
        event.$emit('updateSummary', this.display, { chargeInfo: this.chargeInfo }, causes)
        this.step++
      }
    },
    getDate (val) {
      return moment().subtract(parseInt(val), 'days').format('YYYY-MM-DD')
    },
    async last1MonthPayments () {
      this.expandCustomList = false
      this.billerFilter = ''
      this.billHistoryInput = {}
      this.billHistoryInput.limit = this.limit
      this.billHistoryInput.offset = this.offset
      this.billHistoryInput.partyId = JSON.parse(
        sessionStorage.getItem('username')
      )
      this.billHistoryInput.fromDate = this.getDate(29)
      this.billHistoryInput.toDate = this.currentDate
      await this.getBillPaymentHistory()
    },
    async last2MonthsPayments () {
      this.expandCustomList = false
      this.billerFilter = ''
      this.billHistoryInput = {}
      this.billHistoryInput.limit = this.limit
      this.billHistoryInput.offset = this.offset
      this.billHistoryInput.partyId = JSON.parse(
        sessionStorage.getItem('username')
      )
      this.billHistoryInput.fromDate = this.getDate(59)
      this.billHistoryInput.toDate = this.currentDate
      await this.getBillPaymentHistory()
    },
    async last6MonthsPayments () {
      this.expandCustomList = false
      this.billerFilter = ''
      this.billHistoryInput = {}
      this.billHistoryInput.limit = this.limit
      this.billHistoryInput.offset = this.offset
      this.billHistoryInput.partyId = JSON.parse(
        sessionStorage.getItem('username')
      )
      this.billHistoryInput.fromDate = this.getDate(179)
      this.billHistoryInput.toDate = this.currentDate
      await this.getBillPaymentHistory()
    },
    showCustomFilterList () {
      this.billerFilter = ''
      this.expandCustomList = true
    },
    async getBillPaymentHistory () {
      this.pageNumbers = 2
      const response = await CommonService.billPaymentHistory(
        this.billHistoryInput
      )
      this.paymentHistory = response && response.items ? response.items : []
      this.itemLinks = response && response.links ? response.links : {}
      this.paymentUnfiltered = this.paymentHistory
      if (this.offset === 0) { this.pagination.page = 1 }
      this.setData()
    },
    gotoBillPayments () {
      this.$router.push({ name: 'billPayments', params: { enableNewPayment: true } })
    }
  }
}
</script>
